import request from '@/utils/request'

export function getStatCount(params) {
    return request({
        url: '/v2/sec/dashBoard/getStatCount',
        method: 'post',
        data: params
    })
}